import TermList from "../AdminTermList";

export default class AdminTermListBusinessSupportRequestResolution extends TermList {
    /**
     * @returns {string} The term type.
     */
    getType() {
        return "businesss_support_request_resolution";
    }
}
